module.exports = __webpack_public_path__ + "static/media/02.4d4f771d.mp3";